"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMemoryStorage = void 0;
class AppMemoryStorage {
    constructor() {
        this.length = 0;
        this.allKeys = [];
    }
    clear() {
        this.allKeys.forEach(key => delete this[key]);
        this.allKeys = [];
        this.length = 0;
    }
    getItem(key) {
        return this[key] || null;
    }
    key(index) {
        return this.allKeys[index];
    }
    removeItem(key) {
        delete this[key];
        const index = this.allKeys.indexOf(key);
        if (index > -1) {
            this.allKeys.splice(index, 1);
        }
        this.length = this.allKeys.length;
    }
    setItem(key, value) {
        this[key] = value;
        this.length = this.allKeys.length;
    }
}
exports.AppMemoryStorage = AppMemoryStorage;
//# sourceMappingURL=AppMemoryStorage.js.map